// index.js
import React, { useCallback } from "react";
import { Helmet } from "react-helmet";
import "./service.css";

import Footer from "../../components/Footer/footer";
import ServicesHero from "./Component/ServicesHero/ServicesHero";
import ServicesList from "./Component/ServicesList/ServicesList";
import ServicesCTA from "./Component/ServicesCTA/ServicesCTA";
import ServicesWhyChoose from "./Component/ServicesWhyChoose/ServicesWhyChoose";

const ServicePage = () => {

  return (
    <>
      <Helmet>
        <title>Web Development Services in Ahmedabad | BA Code Solutions</title>

        <meta
          name="description"
          content="BA Code Solutions offers web development services in Ahmedabad including React app development, responsive websites, UI/UX design, and custom business solutions."
        />

        <meta
          name="keywords"
          content="web development services Ahmedabad, react development services, website design India, frontend development, custom web solutions"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Web Development Services | BA Code Solutions"
        />
        <meta
          property="og:description"
          content="Explore our professional web development services including React apps and custom websites."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://bacodesolutions.com/services"
        />
        <meta
          property="og:image"
          content="https://bacodesolutions.com/logo192.png"
        />
      </Helmet>
      <ServicesHero />
      <ServicesList />
      <ServicesWhyChoose />
      <ServicesCTA />
      <Footer />
    </>
  );
};

export default ServicePage;
